"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getUserCacheKey = exports.getHashValue = exports.SimpleHash = void 0;
function SimpleHash(value) {
    var hash = 0;
    for (var i = 0; i < value.length; i++) {
        var character = value.charCodeAt(i);
        hash = (hash << 5) - hash + character;
        hash = hash & hash; // Convert to 32bit integer
    }
    return String(hash >>> 0);
}
exports.SimpleHash = SimpleHash;
function getHashValue(value) {
    return SimpleHash(value);
}
exports.getHashValue = getHashValue;
function getUserCacheKey(user) {
    var _a;
    var key = "userID:".concat(String((_a = user === null || user === void 0 ? void 0 : user.userID) !== null && _a !== void 0 ? _a : ''));
    var customIDs = user === null || user === void 0 ? void 0 : user.customIDs;
    if (customIDs != null) {
        for (var _i = 0, _b = Object.entries(customIDs); _i < _b.length; _i++) {
            var _c = _b[_i], type = _c[0], value = _c[1];
            key += ";".concat(type, ":").concat(value);
        }
    }
    return SimpleHash(key);
}
exports.getUserCacheKey = getUserCacheKey;
